import { combineReducers } from 'redux';
import app from './app';
import quizz from './quizz';
import registration from './registration';

export default combineReducers({
  app: app,
  quizz: quizz,
  registration: registration
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/stores/index.js
// module id = 529
// module chunks = 0